<template>
  <div class="default-modal rc-modal">
    <div class="default-modal__header">
      <h3 class="default-modal__title">Написать отзыв</h3>
      <button type="button" class="default-modal__close" @click="$emit('close')">
        <IconComponent name="add" />
      </button>
    </div>
    <div class="default-modal__body rc-modal__body">
      <div v-if="data && data.title" class="rc-modal__product">
        <span>Отзыв на:</span>
        <template v-if="data.brand && data.brand.title">{{ data.brand.title }} /</template>
        {{ data.title }}
      </div>
      <InputComponent
        v-model.trim="form.name.value"
        :error="form.name.error"
        title="Как вас зовут?"
        :disabled="anonymous"
      />
      <CheckboxComponent :checked="anonymous" @change="anonymous = !anonymous">
        <span>Анонимно</span>
      </CheckboxComponent>
      <div class="rc-modal__mark">
        <span class="rc-modal__mark-title">
          <template v-if="form.mark.value"> Оценка: {{ getMarkTitle() }} </template>
          <template v-else>Оценка</template>
        </span>
        <div class="rc-modal__stars">
          <label
            @mouseover="hoverMark = i"
            @mouseleave="hoverMark = null"
            v-for="i in 5"
            :key="i"
            class="btn"
          >
            <input v-model="form.mark.value" type="radio" class="hidden" :value="i" />
            <IconComponent
              class="rc-modal__star"
              :class="{
                'rc-modal__star--filled': hoverMark >= i || form.mark.value >= i,
                'rc-modal__star--opacity': hoverMark && i > hoverMark && i <= form.mark.value,
              }"
              name="star-fill"
            />
          </label>
        </div>
      </div>
      <TextareaComponent
        v-model="form.description.value"
        title="Отзыв"
        placeholder="Текст"
        :subtitle="form.description.message"
        :error="form.description.error"
      />
      <TextareaComponent
        v-model="form.pros.value"
        title="Плюсы"
        placeholder="Текст"
        :subtitle="form.pros.message"
        :error="form.pros.error"
      />
      <TextareaComponent
        v-model="form.cons.value"
        title="Минусы"
        placeholder="Текст"
        :subtitle="form.cons.message"
        :error="form.cons.error"
      />
      <InputComponent
        v-if="canAddVideo"
        v-model.trim="form.video_link.value"
        :error="form.video_link.error"
        title="Ссылка на видео (YouTube) или код для вставки"
      />
      <!--      <SelectComponent-->
      <!--        v-model="form.using_time.value"-->
      <!--        :options="using_times"-->
      <!--        :errors="form.using_time.error"-->
      <!--        label-name="title"-->
      <!--        title="Срок использования"-->
      <!--        selectTitle="Выберите период"-->
      <!--      />-->
    </div>
    <div class="default-modal__footer rc-modal__footer">
      <button @click="reviewCreate" type="button" class="btn btn--md btn--main">
        <FileIconComponent v-if="loading" name="loading" />
        <template v-else>Отправить</template>
      </button>
    </div>
  </div>
</template>

<script>
import InputComponent from "components/inputs/InputComponent.vue";
import FileIconComponent from "components/FileIconComponent.vue";
import TextareaComponent from "components/inputs/TextareaComponent.vue";
import CheckboxComponent from "components/inputs/CheckboxComponent.vue";
import REVIEW_CREATE from "gql/mutations/ReviewCreate.graphql";
import SelectComponent from "components/inputs/select/index.vue";
import IconComponent from "components/IconComponent.vue";

export default {
  name: "ReviewCreateModal",
  props: {
    data: Object,
    reviewable_type: String,
    canAddVideo: Boolean,
    callback: Function,
  },
  data() {
    return {
      hoverMark: null,
      anonymous: false,
      loading: false,
      using_times: [
        {
          id: 1,
          title: "Меньше месяца",
          value: 1,
        },
        {
          id: 2,
          title: "От месяца до полугода",
          value: 2,
        },
        {
          id: 3,
          title: "Больше полугода",
          value: 3,
        },
        {
          id: 4,
          title: "Больше года",
          value: 4,
        },
      ],
      form: {
        name: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        description: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        pros: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        cons: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        mark: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        video_link: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        using_time: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
  },
  mounted() {
    if (this.user && this.user.name) {
      this.form.name.value = this.user.name;
    }
  },
  methods: {
    reviewCreate() {
      if (!this.loading) {
        this.loading = true;
        this.$apollo.provider.defaultClient
          .mutate({
            mutation: REVIEW_CREATE,
            variables: {
              name: this.anonymous ? undefined : this.form.name.value,
              description: this.form.description.value,
              pros: this.form.pros.value,
              cons: this.form.cons.value,
              reviewable_id: this.data?.id,
              mark: this.form.mark.value,
              video_link: this.form.video_link.value,
              reviewable_type: this.reviewable_type,
            },
            context: {
              headers: {
                Authorization: "Bearer " + this.$store.state.apollo_token,
              },
            },
          })
          .then(({ data }) => {
            this.$emit("close");
            this.$notify({
              title: "Отправлено",
              text: data.ReviewCreate.message,
              duration: 5000,
              speed: 200,
              type: "success",
            });
            this.loading = false;
            this.callback();
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    getMarkTitle() {
      switch (this.form.mark.value) {
        case 1: {
          return "Ужасно";
        }
        case 2: {
          return "Плохо";
        }
        case 3: {
          return "Удовлетворительно";
        }
        case 4: {
          return "Хорошо";
        }
        case 5: {
          return "Отлично";
        }
      }
    },
  },
  components: {
    IconComponent,
    SelectComponent,
    CheckboxComponent,
    TextareaComponent,
    FileIconComponent,
    InputComponent,
  },
};
</script>

<style lang="stylus">
.rc-modal {
  width 100%
  max-width 500px

  &__body {
    display grid
    justify-content stretch
    align-items stretch
    gap 12px

    .textarea__field {
      height 100px
    }
  }

  &__body .input,
  &__footer .btn {
    width 100%
  }

  &__product {
    display flex
    gap 8px

    span {
      flex-shrink 0
    }
  }

  &__mark {
    display flex
    flex-direction column
    gap 4px

    &-title {
      font-weight: normal;
      font-size: 0.875em;
      line-height: 20px;
      color: var(--body-color-muted);
    }

    .btn:hover .icon svg path {
      fill var(--main-color)
    }
  }

  &__stars {
    display inline-flex
    align-items center
    justify-content flex-start
    margin 0 -4px

    .btn {
      padding 0 4px
    }
  }

  &__star {
    width 24px
    height 24px

    &:not(&--filled) {
      svg path {
        fill transparent
        stroke var(--yellow)
      }
    }

    &--filled {
      svg path {
        stroke var(--yellow)
        fill var(--yellow)
      }
    }

    &--opacity {
      opacity 0.5
    }
  }
}
</style>
